<template>
  <div class="mx-4">
    <v-card
      elevation="3"
      class="mx-auto my-8 pa-8 text-center rounded-lg"
      max-width="900"
      v-if="!isLoading"
    >
      <v-avatar size="x-large">
        <v-img :src="voteData.business.image"></v-img>
      </v-avatar>
      <h6 class="text-16 font-bold mt-2">
        {{ voteData.business.name }}
      </h6>
      <p v-if="voteData.voter.name != null" class="text-14 font-light mt-2">
        {{ voteData.voter.name }} عزیز
      </p>

      <v-row class="mt-8">
        <v-col
          style="padding: 6px"
          cols="12"
          lg="6"
          md="6"
          sm="12"
          xs="12"
          v-for="vote in voteData.votes"
          :key="vote.id"
        >
          <v-card height="162" class="pa-6 rounded-lg" variant="outlined">
            <p class="text-14 font-bold">
              {{ vote.title }}
            </p>
            <!-- <Rating class="mt-4" :rate="vote.rating" ></Rating> -->
            <StarRating
              class="justify-center mt-7"
              v-model:rating="vote.rating"
              :padding="12"
              :show-rating="false"
              :rounded-corners="true"
              :star-size="36"
              :animate="true"
            ></StarRating>
          </v-card>
        </v-col>
      </v-row>
      <v-text-field
        v-model="city"
        class="mt-8 rtl"
        background-color="orange"
        color="orange orange-darken-4"
        label="شهر مبدا خود را وارد نمایید"
      >
      </v-text-field>

      <v-textarea
        rows="2"
        v-model="comment"
        class="mt-8 rtl"
        background-color="orange"
        color="orange orange-darken-4"
        label="انتقاد و پیشنهادات"
      >
      </v-textarea>

      <v-btn flat color="orange" class="font-medium" block @click="addVote">
        <v-progress-circular
          v-if="isBtnLoading"
          indeterminate
          color="black"
          size="18"
          :width="2"
        />
        <p v-else>ثبت نظر</p>
      </v-btn>

      <p class="mt-8 text-12">
        ساخته شده توسط
        <a style="text-decoration: none" href="https://namya.ir">نامیا</a>
      </p>
    </v-card>

    <LoadingOverlay :show="isLoading" />
    <FinishedOverlay :show="isFinished" />
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRoute } from "vue-router";
import axios from "axios";
import StarRating from "@/components/StarRating.vue";
import FinishedOverlay from "@/components/FinishedOverlay.vue";
import LoadingOverlay from "@/components/LoadingOverlay.vue";

const city = ref("");
const comment = ref("");
const isLoading = ref(true);
const isBtnLoading = ref(false);
const isFinished = ref(false);
const exit = ref("exit");
const voteData = ref({
  business: { name: null, image: null },
  votes: null,
  voter: null,
});
// const link = "tZMjUXtD";
// const link = "Xc8tybOL";
const { link } = useRoute().query;

async function getVoteData() {
  if (link != null) {
    try {
      const voteRequest = await axios.get(
        "https://namya.ir/api/v1/businesses/vote?link=" + link
      );
      console.log(voteRequest);
      voteData.value = voteRequest.data.data;
      isLoading.value = false;
    } catch (error) {
      if (error.response.status == 404) {
        isLoading.value = false;
        isFinished.value = true;
      }
    }
  }
}

async function addVote() {
  isBtnLoading.value = true;
  try {
    console.log({
      link: link,
      comment: city.value + "-" + comment.value,
      votes: voteData.value.votes.map((vote) => ({
        vote_id: vote.vote_id,
        rate: vote.rating,
      })),
    });

    const voteRequest = await axios.post(
      "https://namya.ir/api/v1/businesses/votes/answer",
      {
        link: link,
        comment: city.value + "-" + comment.value,
        votes: voteData.value.votes.map((vote) => ({
          vote_id: vote.vote_id,
          rate: vote.rating,
        })),
      }
    );
    isFinished.value = true;
  } catch (error) {
    console.log(error);
  }

  isBtnLoading.value = false;
}

getVoteData();
</script>

<style>
.v-btn {
  letter-spacing: 0 !important;
}
.vue-star-rating[data-v-6ac6593f] {
  display: flex;
  align-items: center;
}
.v-img__img,
.v-img__picture,
.v-img__gradient,
.v-img__placeholder,
.v-img__error {
  z-index: 9999 !important;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
